import { __awaiter, __generator } from "tslib";
import { ChartLegendKey } from '.';
import { createCheckboxGroupDriver } from '../../composites/checkbox-group/driver';
import { createActionsMenuButtonDriver } from '../../composites/drivers';
export var createChartLegendDriver = function (wrapper, global) {
    var base = wrapper.$("." + ChartLegendKey);
    var moreLabelsDriver = createActionsMenuButtonDriver(base, global);
    return {
        getLabelNames: function () { return base.$$('.label-name').text(); },
        getLabelValues: function () { return base.$$('.label-value').map(function (item) { return __awaiter(void 0, void 0, void 0, function () { var _a; return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = parseInt;
                    return [4 /*yield*/, item.text()];
                case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent(), 10])];
            }
        }); }); }); },
        getSelectedLabels: function () { return base.$$('.legend-label-view.selected .label-name').text(); },
        clickLegendLabelByIndex: function (idx) { return base.$$('.legend-label-view').get(idx).click(); },
        isMoreLabelsVisible: function () { return moreLabelsDriver.base.exists(); },
        moreMenu: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, moreLabelsDriver.openMenu()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, createCheckboxGroupDriver(moreLabelsDriver.getMenuDriver())];
                }
            });
        }); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map